import createListViewContext, { type FilterValues } from 'global/helpers/createListViewContext'

export interface RejectedMessagesFilterValues extends FilterValues {
  keywords: string[]
}

const defaultFilters: RejectedMessagesFilterValues = {
  keywords: [],
}

const { ListViewProvider, useListView } = createListViewContext(defaultFilters)

export { ListViewProvider as RejectedMessagesViewProvider, useListView as useRejectedMessagesView }
